import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Documents from '../../components/Documents';
import { selectAuthenticatedUser } from '../../store/selectors/auth'
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectDocuments } from '../../store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/uploadDocument';
import moment from 'moment';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { startFormLoading } from '../../store/actions/loader';
import {sortDocumentsList} from "../../helpers/CommonHelpers"

class ContactDocuments extends Component {
  
  constructor(props) {
    super(props);
  }

  state = {
   loading:true
  };

  componentDidMount() {
    this.props.clearSearch()

    // Modified by: Tarkeshwar Prasad Yadav
    // Modified on: 23/08/2022
    // Jira ticket: JUN-3051
    // Comment: Added setTimeout to give enough time to filter data and to set all the relevant data to show.
    setTimeout(()=>this.setState({loading:false}),3000)
  }

  onSave = async (document) => {
    this.props.onStartFormLoading();
    let image = null
    if(document && document.image && document.image.length > 0 && document.image[0].path){
      let path = document.image[0].path;
      let newFileName = path.split(/\.(?=[^\.]+$)/)[0] + moment().format('MMDDYYYYhmmss') + '.' + path.split(/\.(?=[^\.]+$)/)[1]
      image =  await upload(document.image[0], newFileName.replace(/ /g,''))
      document = document = {...document,image}
    }
    const { uploadType, ...documentData } = document;
    let data = {
      ItemId: this.props.contact.id,
      Name: 'DOCUMENTS',
      Type: 'DOCUMENTS',
      Data: JSON.stringify(documentData).toString(),
      UserId: this.props.user.userId
    }
    this.props.onSaveFaqsNotesDocuments(data)

  }
  onDeleteFaqsNotesDocuments(document){
    document.Type = 'DOCUMENTS';
    this.props.onDeleteFaqsNotesDocuments(document)
  }
  render() {
    const { documents, contact,setSearch, loader } = this.props;
    
    // Modified By: Anjali
    // Modified On: 22-11-2023
    // Jira-Id: https://bosframework.atlassian.net/browse/JUN-3930
    // Reason: Items in the manuals & documents section need to be sorted alphabetically across all areas of Juniper (suite level, individual item level) -only property changed in 3898
    
    const sortDocuments = sortDocumentsList(documents)

    return (
      this.state.loading ? <Loader /> :
      <Documents
        breadcrumb={contact.firstname + ' ' + contact.lastname}
        documents={sortDocuments}
        onSaveDocument={ (document) => this.onSave(document)}
        onDeleteDocument={(document) => this.onDeleteFaqsNotesDocuments(document)}
        onSearch={e => setSearch({ documents: e.target.value.trim() })}
        labelName={"Manuals & Documents"}
        from={"Contact"}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user:selectAuthenticatedUser(state),
  documents: selectDocuments(state),
  loader: selectPRLoader(state),

});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocumentss: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments:saveFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  onStartFormLoading: startFormLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactDocuments);
